import React from 'react';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

/**
 * Success confirmation shared by every dashboard entity's create/update flow
 * (Roles today, Collaborators/Campaigns next) — top-center, an `Alert`
 * (not a bare `message`) so it reads as a clear success signal instead of a
 * generic toast. Keep this component when a new entity needs the same
 * "saved successfully" feedback rather than rebuilding it per page.
 */
export default function SuccessSnackbar({ open, message, onClose, autoHideDuration = 4000 }) {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    onClose?.();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={() => onClose?.()} severity="success" variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
